import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const setBestRouteStations = (
  state: StationsState,
  action: PayloadAction<StationsState['bestRouteStations']['data']>
) => {
  state.bestRouteStations.data = action.payload;
}